export default {
    "98a0597d": {
        "name": "Anime Land",
        "product": "XK-401",
        "mbit": "16",
        "fullCrc": "3fd9713b",
        "internalCrc": "98a0597d"
    },
    "7cb100b3": {
        "name": "HARIHARI Seal Paradise",
        "product": "XK-402",
        "mbit": "16",
        "fullCrc": "b82ac7f3",
        "internalCrc": "7cb100b3"
    },
    "f6d41645": {
        "name": "Dream Change - Kogane-chan no Fashion Party",
        "product": "XK-403",
        "mbit": "16",
        "fullCrc": "0fb0a794",
        "internalCrc": "f6d41645"
    },
    "2046476f": {
        "name": "Nigaoe Artist",
        "product": "XK-404",
        "mbit": "16",
        "fullCrc": "ef1b33f3",
        "internalCrc": "2046476f"
    },
    "a5341f72": {
        "name": "Chakrakun no Omajinai Paradise",
        "product": "XK-405",
        "mbit": "16",
        "fullCrc": "955c56ea",
        "internalCrc": "a5341f72"
    },
    "d90fe762": {
        "name": "Wanwan Aijou Monogatari",
        "product": "XK-501",
        "mbit": "16",
        "fullCrc": "10c5f568",
        "internalCrc": "d90fe762"
    },
    "b5be48d7": {
        "name": "Puppy Love Story [T-En]",
        "product": "XK-501",
        "mbit": "16",
        "fullCrc": "038a02a9",
        "internalCrc": "b5be48d7"
    },
    "f294f931": {
        "name": "Pasocom Collection",
        "product": "XK-502",
        "mbit": "16",
        "fullCrc": "fe3be881",
        "internalCrc": "f294f931"
    },
    "6a410bb2": {
        "name": "Little Romance",
        "product": "XK-503",
        "mbit": "24",
        "fullCrc": "550616f0",
        "internalCrc": "6a410bb2"
    },
    "8373e9dd": {
        "name": "Loopy Town no Oheya ga Hoshii!",
        "product": "XK-504",
        "mbit": "24",
        "fullCrc": "352b4ae6",
        "internalCrc": "8373e9dd"
    },
    "6e00ce71": {
        "name": "Lupiton no Wonder Palette",
        "product": "XK-701",
        "mbit": "16",
        "fullCrc": "f4662e66",
        "internalCrc": "6e00ce71"
    }
};
